var $ = jQuery;
var $document = $(document);

$document.on('click', '.sub-menu-toggle', function() {

    var $this = $(this);
    var $parent = $this.closest('.menu-item-has-children');

    $parent.toggleClass('menu-open');

});
